import { render, staticRenderFns } from "./ReviewerReport.vue?vue&type=template&id=8739e032&scoped=true&"
import script from "./ReviewerReport.vue?vue&type=script&lang=ts&"
export * from "./ReviewerReport.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewerReport.vue?vue&type=style&index=0&id=8739e032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8739e032",
  null
  
)

export default component.exports